import { render, staticRenderFns } from "./genericGridComponent.vue?vue&type=template&id=7643752f&"
import script from "./genericGridComponent.vue?vue&type=script&lang=js&"
export * from "./genericGridComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports